import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'libs/shared/src/lib/services/auth.service';
import { User } from '../../models/user';

@Component({ standalone: false,
  selector: 'vfa-cp-security-questions-form',
  templateUrl: './security-questions-form.component.html',
  styleUrls: ['./security-questions-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SecurityQuestionsFormComponent implements OnChanges {
  @Input() waitSave: boolean = false;
  @Input() title: any;
  @Input() description: any;
  @Input() noData: any;
  @Input() contact: any = null;
  @Input() securityQuestions1: any = [];
  @Input() securityQuestions2: any = [];
  @Output() validateQuestions: EventEmitter<any> = new EventEmitter();
  public req: any;
  public securityQuestionsForm: FormGroup = new FormGroup({});
  public updatedQuestions1: any;
  private update1: boolean = false;
  public updatedQuestions2: any;
  private update2: boolean = false;
  public patternNumbers = new RegExp('[0-9]');


  constructor(private authService: AuthService) {
  }

  ngOnChanges(changes: any) {
    if (changes && changes.contact) {
      this.createForm(this.contact);
    } if(changes && changes.waitSave.currentValue === true) {
      this.securityQuestionsForm.disable();
    } else if (changes && changes.waitSave.currentValue === false) {
      this.securityQuestionsForm.enable();
    }
  }

  private createForm(res: any) {
    this.securityQuestionsForm = new FormGroup({
      Identification_Question1__c: new FormControl({ value: res.Account.Identification_Question1__c ? res.Account.Identification_Question1__c : '' }, Validators.required),
      Identification_Answer1__c: new FormControl({ value: res.Account.Identification_Answer1__c ? res.Account.Identification_Answer1__c : '' }, [Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(4), Validators.maxLength(4)]),
      Identification_Question2__c: new FormControl({ value: res.Account.Identification_Question2__c ? res.Account.Identification_Question2__c : '' }, Validators.required),
      Identification_Answer2__c: new FormControl({ value: res.Account.Identification_Answer2__c ? res.Account.Identification_Answer2__c : '' }, [Validators.required, Validators.maxLength(50)]),
      // Identification_Question3__c: new FormControl({ value: res.Account.Identification_Question3__c ? res.Account.Identification_Question3__c : '' }, res.Account.Identification_Answer3__c ? Validators.required : null),
      // Identification_Answer3__c: new FormControl({ value: res.Account.Identification_Answer3__c ? res.Account.Identification_Answer3__c : '' }, res.Account.Identification_Question3__c ? Validators.required : null),
    });
    this.req = new User(res);
    this.checkQuestionsAndAnswers();
  }

  private checkQuestionsAndAnswers() {
    if(!this.f.Identification_Question1__c.value.value) {
      if(!this.req.Account.Identification_Question1__c ) {
        this.req.Account.Identification_Question1__c = this.securityQuestions1[0];
      }
    } else {
      const found = this.securityQuestions1.filter((q: any) => q === this.req.Account.Identification_Question1__c);
      if(!found.length) {
        this.f.Identification_Question1__c.value = null;
        this.req.Account.Identification_Question1__c = null;
      }
    }
    if(!this.req.Account.Identification_Answer1__c ) {
      this.req.Account.Identification_Answer1__c = this.req.MobilePhone.substr(this.req.MobilePhone.length - 4);
    }
    if(!this.f.Identification_Question2__c.value.value) {
      if(!this.req.Account.Identification_Question2__c ) {
        this.req.Account.Identification_Question2__c = this.securityQuestions2[0];
      }
    } else {
      const found = this.securityQuestions2.filter((q: any) => q === this.req.Account.Identification_Question2__c);
      if(!found.length) {
        this.f.Identification_Question2__c.value = null;
        this.req.Account.Identification_Question2__c = null;
      }
    }
    if(!this.req.Account.Identification_Answer2__c ) {
      this.req.Account.Identification_Answer2__c = this.req.Account.BillingPostalCode;
    }
  }

  get f(): any {
    return this.securityQuestionsForm.controls;
  }

  public updateQuestion1(event: any) {
    if(this.update1 === true){
      this.req.Account.Identification_Answer1__c = "";
    } else {
      this.update1 = true;
    }
  }

  public updateQuestion2(event: any) {
    if(this.update2 === true){
      this.req.Account.Identification_Answer2__c = "";
    } else {
      this.update2 = true;
    }
  }

  public saveQuestions() {
    if (!this.securityQuestionsForm.valid) {
      const msg = this.authService.instant('personal-info-error-missing-fields');
      this.authService.showToast(msg, 'danger');
      this.securityQuestionsForm.markAllAsTouched();
      return;
    }
    this.validateQuestions.emit(this.req);
  }

  // public checkValidatorsAnswer2(){
  //   if(this.req.Account.Identification_Question2__c === this.securityQuestions2[0]){
  //     this.securityQuestionsForm.get('Identification_Answer2__c')?.addValidators(Validators.pattern('^[0-9]*$'));
  //   } else{
  //     this.securityQuestionsForm.get('Identification_Answer2__c')?.clearValidators();
  //     this.securityQuestionsForm.get('Identification_Answer2__c')?.addValidators(Validators.required);
  //   }
  //   this.securityQuestionsForm.updateValueAndValidity();
  // }
}

